import React from 'react';
import styled from 'styled-components';

export const PageTitle = styled.h1`
  margin: 0;
  font-size: var(--font-size-3xl);
  font-weight: 600;
  line-height: 1.25;
  letter-spacing: -0.035em;
  color: var(--text-primary);
  overflow-wrap: anywhere;
  @media (max-width: 767px) {
    font-size: var(--font-size-2xl);
  }
`;
export const PageDescription = styled.p`
  margin: 0.5rem 0 0;
  max-width: 65ch;
  color: var(--text-muted);
  font-size: 0.875rem;
  line-height: 1.6;
`;
const Header = styled.header`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1.5rem;
  > div {
    min-width: 0;
  }
`;
export const PageHeader: React.FC<{
  title: string;
  description?: React.ReactNode;
  actions?: React.ReactNode;
}> = ({ title, description, actions }) => (
  <Header>
    <div>
      <PageTitle>{title}</PageTitle>
      {description && <PageDescription>{description}</PageDescription>}
    </div>
    {actions && <div>{actions}</div>}
  </Header>
);
